import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.less'],
})
export class FileUploadComponent implements OnInit {
  @Output() fileUploaded: EventEmitter<string> = new EventEmitter();
  loading = false;
  avatarUrl?: string;
  baseUrl = g.apiBaseUrl;
  urlSuffix = g.getUrlSuffix();
  @Input() isImage = false;
  //@Input() name = '';

  constructor(private msg: NzMessageService) {}

  ngOnInit(): void {
    //console.log(this.name);
  }

  fileUploadedSuccessfully(event: NzUploadChangeParam) {
    if (event.type === 'success') {
      const response = event.fileList[0].response;
      if (response.Has_Error) {
        this.msg.error(response.Error_Message);
      } else {
        this.fileUploaded.emit(response.Resault_Value);
      }
    }
    console.log(event);
  }
}
